import { render, staticRenderFns } from "./AgregaFamiliar.vue?vue&type=template&id=216159f8"
import script from "./AgregaFamiliar.vue?vue&type=script&lang=js"
export * from "./AgregaFamiliar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports